// utils/cookieUtils.ts
import Cookies from "js-cookie";
import { UrlParam } from "./api-services";

const VERY_LONG_TIME = 10000;

export function setUTMCookies(
  utm_campaign: string = "",
  utm_medium: string = "",
  utm_source: string = ""
) {
  utm_campaign && Cookies.set("utm_campaign", utm_campaign, { expires: VERY_LONG_TIME });
  utm_medium && Cookies.set("utm_medium", utm_medium, { expires: VERY_LONG_TIME });
  utm_source && Cookies.set("utm_source", utm_source, { expires: VERY_LONG_TIME });
}

export function getUTMCookies() {
  const utm_campaign = Cookies.get("utm_campaign");
  const utm_medium = Cookies.get("utm_medium");
  const utm_source = Cookies.get("utm_source");

  const utm_cookies = {
    ...(utm_campaign && { utm_campaign }),
    ...(utm_medium && { utm_medium }),
    ...(utm_source && { utm_source })
  };

  return utm_cookies;
}

export function convertUtmCookiesToParams(
  utmCookies: Record<string, string>
): UrlParam[] {
  return Object.keys(utmCookies).map(key => ({
    param: key,
    value: utmCookies[key]
  }));
}
